import React from "react";
import AdminAppBody from "../../components/admin/AdminAppBody";

const HomePage = () => {
  return <AdminAppBody content={<div>Home Page</div>} />;
};

export default HomePage;
